<template>
  <div id="app" v-if="ready">
    <div id="nav" v-if="sidebar">
      <z-menu
        :isMenuOpen="isMenuOpen"
        :updateMenu="isOpen => (isMenuOpen = isOpen)"
      />
    </div>
    <div id="main">
      <div class="topbar" v-if="topbar">
        <Topbar
          :isMenuOpen="isMenuOpen"
          :updateMenu="isOpen => (isMenuOpen = isOpen)"
        />
      </div>
      <div id="view" class="padded">
        <transition name="fade" mode="out-in">
          <router-view />
        </transition>
      </div>
    </div>
  </div>
  <div v-else>
    Carregando...
  </div>
</template>

<script>
import ZMenu from '../layout/Menu.vue';
import Topbar from '../layout/Topbar.vue'

export default {
  data() {
    return {
      isMenuOpen: false
    };
  },
  computed: {
    ready() {
      return this.$auth.ready();
    },
    sidebar() {
      return typeof this.$route.meta.sidebar !== 'undefined' ? this.$route.meta.sidebar : true;
    },
    topbar() {
      return typeof this.$route.meta.topbar !== 'undefined' ? this.$route.meta.topbar : true;
    },
    isfullsize() {
      return typeof this.$route.meta.fullsize !== undefined ? this.$route.meta.fullsize : true;
    },
    padded() {
      return (this.topbar || this.sidebar) && !this.isfullsize;
    },
    fullsize() {
      return this.isfullsize;
    },
  },
  components: {
    ZMenu,
    Topbar,
  },
};
</script>

<style lang="scss">
// Import Bulma and Buefy styles
@import '../assets/scss/app.scss';

</style>
